const staticRouter = [
  {
    path: '/',
    name: 'home',
    // redirect: {
    //   name: 'ProductLibrary2',
    // },
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: 'Login',
      requireAuth: false,
      isAuth:false
    },
    component: () => import('../views/login/index.vue'),
  },
  //新增一个注册页面
  {
    path: '/register',
    name: 'Register',
    meta: {
      title: 'Register',
    },
    component: () => import('../views/Register.vue'),
    children: [
      {
        path: '/register/info',
        name: 'RegisterInfo',
        meta: {
          title: 'Register',
          isAuth: false,
        },
        component: () => import('../views/register/index.vue'),
      },
    ],
  },
  {
    path:'/auth/sso',
    name:'authredirect',
    meta:{
      title:'Auth Redirect',
      isAuth: false,
    },
    component: () => import('../views/authredirect.vue')
  },
  {
    path: '/layout',
    name: 'Layout',
    component: () => import('../views/Layout.vue'),
    children: [
      // 404页面
      {
        path: '/404',
        name: '404',
        component: () => import('../views/Error.vue'),
        meta: {
          title: '404',
          requireAuth: false,
        },
      },
      {
        path: '/:pathMatch(.*)*',
        name: 'undefined',
        meta: {
          title: 'No Page Found',
          requireAuth: false,
        },
        redirect: '/404',
      },

      /* TRF List */
      {
        path: '/trf/list',
        name: 'TrfList',
        meta: {
          title: 'TRF List',
          requireAuth: false,
        },
        component: () => import('@/views/trf/list/index.vue'),
      },
      /* protocol */
      {
        path: '/protocol/list',
        name: 'ProtocolList',
        meta: {
          title: 'Protocol List',
          requireAuth: false,
        },
        component: () => import('@/views/protocol/detail/list.vue'),
      },
      {
        path: '/protocol/detail',
        name: 'ProtocolDetail',
        meta: {
          title: 'Protocol Detail',
          requireAuth: false,
        },
        component: () => import('@/views/protocol/detail/ProtocolDetail.vue'),
      },
      {
        path: '/protocol/v2/detail',
        name: 'ProtocolDetailV2',
        meta: {
          title: 'Protocol Detail',
          requireAuth: false,
        },
        component: () => import('@/views/protocol/detail/ProtocolDetailV2.vue'),
      },
      /* product */
      {
        path: '/customer/newProduct/list',
        name: 'ProductLibrary',
        meta: {
          title: 'Product Library',
          requireAuth: false,
        },
        component: () => import('@/views/product/list/Index.vue'),
      },
      {
        path: '/customer/newProduct/v2/list',
        name: 'ProductLibrary2',
        meta: {
          title: 'Product Library',
          requireAuth: false,
          version: 'v2',
        },
        component: () => import('@/views/product/list/Index3.vue'),
      },
      {
        path: '/customer/newProduct/v3/list',
        name: 'ProductLibrary3',
        meta: {
          title: 'Product Library',
          requireAuth: false,
          version: 'v2',
        },
        component: () => import('@/views/product/list/Index2.vue'),
      },
      {
        path: '/customer/newProduct/detail',
        name: 'ProductDetail',
        meta: {
          title: 'Product Detail',
          requireAuth: false,
        },
        component: () => import('@/views/product/detail/Index.vue'),
      },
      {
        path: '/customer/newProduct/v2/detail',
        name: 'ProductDetail2',
        meta: {
          title: 'Product Detail2',
          requireAuth: false,
          version: 'v2',
        },
        component: () => import('@/views/product/detail/Index2.vue'),
      },
      /* material */
      {
        path: '/customer/newMaterial/list',
        name: 'MaterialLibrary',
        meta: {
          title: 'Material Library',
          requireAuth: false,
        },
        component: () => import('@/views/material/list/Index2.vue'),
      },
      {
        path: '/customer/newMaterial/v2/list',
        name: 'MaterialLibrary2',
        meta: {
          title: 'Material Library',
          requireAuth: false,
          version: 'v2',
        },
        component: () => import('@/views/material/list/Index3.vue'),
      },
      {
        path: '/customer/newMaterial/v3/list',
        name: 'MaterialLibrary3',
        meta: {
          title: 'Material Library',
          requireAuth: false,
          version: 'v2',
        },
        component: () => import('@/views/material/list/Index2.vue'),
      },
      {
        path: '/customer/newMaterial/detail',
        name: 'MaterialDetail',
        meta: {
          title: 'Material Detail',
          requireAuth: false,
        },
        component: () => import('@/views/material/detail/Index.vue'),
      },
      {
        path: '/customer/newMaterial/v2/detail',
        name: 'MaterialDetailV2',
        meta: {
          title: 'Material Detail',
          requireAuth: false,
          version: 'v2',
        },
        component: () => import('@/views/material/detail/Index2.vue'),
      },
      /* company */
      {
        path: '/company/info',
        name: 'Company Info',
        meta: {
          title: 'Company Info',
          requireAuth: false,
        },
        component: () => import('../views/company/info/index.vue')
      },
      {
        path: '/customer/relationship',
        name: 'Customer Relationship',
        meta: {
          title: 'Customer Relationship',
          requireAuth: false,
        },
        component: () => import('../views/customer/relationship/index.vue'),
      },
      {
        path: '/taskcenter/index',
        name: 'Task Center',
        meta: {
          title: 'Task Center',
          requireAuth: false,
        },
        component: () => import('../views/taskcenter/index.vue'),
      },
      /* todo list */
      {
        path: '/todolist/report',
        name: 'Report To Do List',
        meta: {
          title: 'Report To Do List',
          requireAuth: false,
        },
        component: () => import('../views/todolist/report.vue'),
      },
      {
        path: '/todolist/product/:inBoxType(buyer)',
        name: 'Buyer Inbox',
        meta: {
          title: 'Buyer Inbox',
          requireAuth: false,
        },
        component: () => import('../views/todolist/product/inBox.vue'),
      },
      {
        path: '/todolist/product/:inBoxType(supplier)',
        name: 'Supplier Inbox',
        meta: {
          title: 'Supplier Inbox',
          requireAuth: false,
        },
        component: () => import('../views/todolist/product/inBox.vue'),
      },
      {
        path: '/todolist/product/v2/:inBoxType(buyer)',
        name: 'new Buyer Inbox',
        meta: {
          title: 'Buyer Inbox',
          requireAuth: false,
          version: 'v2',
        },
        component: () => import('../views/todolist/product/v2/inBox.vue'),
      },
      {
        path: '/todolist/product/v2/:inBoxType(supplier)',
        name: 'new Supplier Inbox',
        meta: {
          title: 'Supplier Inbox',
          requireAuth: false,
          version: 'v2',
        },
        component: () => import('../views/todolist/product/v2/inBox.vue'),
      },
      /* setting */
      {
        path: '/setting/alias',
        name: 'Alias Setting',
        meta: {
          title: 'Alias Setting',
          requireAuth: false,
        },
        component: () => import('../views/setting/alias/index.vue'),
      },
      //template list
      {
        path: '/customer/template/:templateType',
        name: 'Template List',
        meta: {
          title: 'Template List',
          requireAuth: false,
        },
        component: () => import('@/views/customer/template/list/index.vue'),
      },
      //template detail
      {
        path: '/customer/template/detail',
        name: 'Template Detail',
        meta: {
          title: 'Template Detail',
          requireAuth: false,
        },
        component: () => import('@/views/customer/template/detail/index.vue'),
      },
      //careLabel Setting
      {
        path: '/setting/careLabel',
        name: 'careLabel Setting',
        meta: {
          title: 'careLabel Setting',
          requireAuth: false,
        },
        component: () => import('../views/setting/careLabel/index.vue'),
      },
      {
        path: '/todolist/product/es/:inBoxType(buyer)',
        name: 'Buyer Inbox1',
        meta: {
          title: 'Buyer Inbox',
          requireAuth: false,
        },
        component: () => import('../views/todolist/product/v2/inBoxes.vue'),
      },
      {
        path: '/todolist/product/es/:inBoxType(supplier)',
        name: 'Supplier Inbox1',
        meta: {
          title: 'Supplier Inbox',
          requireAuth: false,
        },
        component: () => import('../views/todolist/product/v2/inBoxes.vue'),
      },
      {
        path: '/customer/newProduct/es/list',
        name: 'ProductLibrary',
        meta: {
          title: 'Product Library',
          requireAuth: false,
          version: 'v2',
        },
        component: () => import('@/views/product/list/Index3es.vue'),
      },
      {
        path: '/customer/newMaterial/es/list',
        name: 'MaterialLibrary',
        meta: {
          title: 'Material Library',
          requireAuth: false,
          version: 'v2',
        },
        component: () => import('@/views/material/list/Index3es.vue'),
      },
      {
        path: '/trf/detail',
        name: 'trf Detail',
        meta: {
          title: 'trf Detail',
          requireAuth: false,
        },
        component: () => import('../views/trf/detail/index.vue'),
        children: [
          {
            path: 'test-result',
            name: 'trf Detail Test Result',
            meta: {
              title: 'TRF Test Result',
              requireAuth: false,
            },
            component: () => import('../views/trf/detail/TrfTestResultRoute.vue'),
          },
          {
            path: 'invoice',
            name: 'trf Detail Invoice',
            meta: {
              title: 'TRF Invoice',
              requireAuth: false,
            },
            component: () => import('../views/trf/detail/TrfInvoiceRoute.vue'),
          },
          {
            path: 'quotation',
            name: 'trf Detail Quotation',
            meta: {
              title: 'TRF Quotation',
              requireAuth: false,
            },
            component: () => import('../views/trf/detail/TrfQuotationRoute.vue'),
          },
        ],
      },
      //quotation and invoice list
      {
        path: '/todo/quotationAndInvoice/list',
        name: 'Quotation And Invoice List',
        meta: {
          title: 'Quotation And Invoice List',
          requireAuth: false,
        },
        component: () => import('../views/todo/quotationAndInvoice/list.vue'),
      },
    ],
  },
]

export { staticRouter }
